export const dataTableKeys = {
    globalSearchValue: 'globalSearchValue',
}

export const actionKeys = {
    view: 'view',
    edit: 'edit',
    delete: 'delete',
}

export const actionTableKeys = {
    action: 'action',
    access: 'access',
    view: 'view',
    edit: 'edit',
    delete: 'delete',
}

export const getSeverity = value => {
    switch (value) {
        case 'INSTOCK':
            return 'success'
        case 'LOWSTOCK':
            return 'warning'
        case 'OUTOFSTOCK':
            return 'danger'
        case 'COMPLETED':
            return 'success'
        case 'PENDING':
            return 'info'
        case 'CANCELED':
            return 'danger'
        case 'REFUNED':
            return 'danger'
        case 'ACTIVE':
            return 'success'
        case 'OFFLINE':
            return 'warning'
        case 'SHIPPING':
            return 'primary'
        case 'FAIL':
            return 'danger'
    }
}
export const bodyList = {
    image: 'image',
    rating: 'rating',
    avatar: 'avatar',
    price: 'price',
    action: 'action',
    status: 'status',
    shipping: 'shipping',
    actionReview: 'actionReview',
}
